// K4.12 round 3: the shell's first entry (bundle/boot.js, linked by index.html before main.js) — starts what the first screen waits for (lib/boot.ts)
// while main.js and its eager chunks still download; main.ts joins the same start.
import { startBoot } from './lib/boot.js';

void startBoot();
